import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { GET, GET_CLAIM_INFO } from '../../../services';
import { openAlert } from '../../../components/alert/hooks';

export const useGetClaimInfo = ({ reset }) => {
  const [data, setData] = useState(null);
  const { isPending, mutate } = useMutation({
    mutationFn: async ({ claimCode }) => {
      const response = await GET(GET_CLAIM_INFO(claimCode));
      return response;
    },
    onSuccess: (response) => {
      const result = response?.result;
      openAlert({
        model: 'message',
        type: 'success',
        message: response?.message,
      });

      const { ...restResult } = result;

      reset({
        ...restResult,
        itemCode: '',
      });
      setData(result);
    },
    onError: (error) => {
      openAlert({
        model: 'message',
        type: 'error',
        message: error?.message,
      });
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    },
  });

  return { isPending, mutate, data };
};
